import createSelectors from './createSelectors';
import Variable from '../models/Variable';

const Select = createSelectors(Variable, {});

export default Select;
